import type { NXGDSNotificationAction } from '@nsftx/seven-nxg-design-system'
import type {
  NotificationRequiredEvent,
  RequireNotificationEventData
} from '@nsftx/seven-client-sdk-integrator'
import { useNotificationsStore } from '#src/stores/notificationsStore'
import type { RetailNotification } from '#src/modules/notifications/interfaces/RetailNotification'

export const mapNotificationRequest = (
  request: RequireNotificationEventData,
  actions?: NXGDSNotificationAction[]
): RetailNotification => ({
  id: `integrator-notification-${crypto.randomUUID()}`,
  variant: request.type,
  text: request.title ? [request.title, request.message] : [request.message],
  timeout: request.timeout || null,
  actions
})

export const handleNotificationRequired = (event: NotificationRequiredEvent) => {
  const store = useNotificationsStore()
  const notification = mapNotificationRequest(event.data)
  const id = notification.id as string

  const actions = event.data.actions?.map<NXGDSNotificationAction>((action) => ({
    text: action.label,
    callback: () => {
      store.resolveNotification(id, {
        action: action.value,
        origin: 'action_click'
      })
    }
  }))

  store.showNotification(
    {
      ...notification,
      actions
    },
    {
      resolve: event.resolve
    }
  )
}
